export function deepEqual<T>(x: T, y: T): boolean {
  if (typeof x !== typeof y) return false;
  switch (typeof x) {
    case 'object':
      if (x === null || y === null) return x === y;
      if (Array.isArray(x) !== Array.isArray(y)) return false;
      if (Array.isArray(x)) return x.length === (y as typeof x).length && x.every((v, i) => deepEqual(v, (y as typeof x)[i]));
      const keysX = Object.keys(x), keysY = Object.keys(y as typeof x);
      if (keysX.length !== keysY.length) return false;
      return keysX.every(key => deepEqual(x[key as keyof T], (y as typeof x)[key as keyof T]));
    default: return x === y;
  }
}